import { render, staticRenderFns } from "./seguimientoGestion.vue?vue&type=template&id=57c544d2&scoped=true"
import script from "./seguimientoGestion.vue?vue&type=script&lang=js"
export * from "./seguimientoGestion.vue?vue&type=script&lang=js"
import style0 from "./seguimientoGestion.vue?vue&type=style&index=0&id=57c544d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c544d2",
  null
  
)

export default component.exports